export default __webpack_public_path__ + "static/media/hacker-rank-3.7c67b4c8.png";